import { render, staticRenderFns } from "./OsInputLookup.vue?vue&type=template&id=251aaf84&scoped=true"
import script from "./OsInputLookup.vue?vue&type=script&lang=ts"
export * from "./OsInputLookup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251aaf84",
  null
  
)

export default component.exports